// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { EditableText as EditableTextBase } from "metabase/common/components/EditableText";

export const Container = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--mb-color-background_page-primary);
  border-bottom: 1px solid var(--mb-color-border-neutral);
  padding: var(--mantine-spacing-md) var(--mantine-spacing-xl);
`;

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
  color: var(--mb-color-text-secondary);
  gap: var(--mantine-spacing-md);
`;

export const EditableText = styled(EditableTextBase)`
  font-weight: bold;
  font-size: 1.3em;
  color: var(--mb-color-text-secondary);
`;

export const ActionButtons = styled.div`
  /* Since the button is borderless, adding the negative margin
     will make it look flush with the container */
  &:last-child {
    margin-right: calc(var(--mantine-spacing-sm) * -1);
  }
`;
